"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importStar(require("@components/Button"));
var apiService_1 = __importDefault(require("@common/services/apiService"));
var Checklist_1 = __importDefault(require("@/react-app/common/components/Checklist"));
var Loading_1 = __importDefault(require("@/react-app/common/components/Loading"));
var Modal_1 = __importDefault(require("@/react-app/common/components/Modal"));
var settingsSlice_1 = require("../../state/settingsSlice");
var store_1 = require("@/redux/store");
var notifier_1 = __importDefault(require("@/react-app/common/utils/notifier"));
function RenewApiKeyModal(_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, hasClipboardSupport = _a.hasClipboardSupport, domain = _a.domain;
    var t = (0, react_i18next_1.useTranslation)(['settings']).t;
    var _b = __read((0, react_1.useState)([
        { id: 0, text: t('settings:API_INTEGRATION.MODAL.TEXT1'), confirmed: false },
        { id: 1, text: t('settings:API_INTEGRATION.MODAL.TEXT2'), confirmed: false },
        { id: 2, text: t('settings:API_INTEGRATION.MODAL.TEXT3'), confirmed: false },
    ]), 2), conditions = _b[0], setConditions = _b[1];
    var isAllConditionsConfirmed = conditions.every(function (condition) { return condition.confirmed; });
    var _c = __read((0, react_1.useState)(false), 2), hasRenewedKey = _c[0], setHasRenewedKey = _c[1];
    var _d = __read((0, react_1.useState)(''), 2), newApiKey = _d[0], setNewApiKey = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), fetchingNewKey = _e[0], setFetchingNewKey = _e[1];
    var apiInputElement = (0, react_1.useRef)(null);
    var dispatch = (0, store_1.useAppDispatch)();
    var renewApiKey = function () {
        setFetchingNewKey(true);
        apiService_1.default.postNewApiKey({ domain: domain })
            .then(function (response) {
            setNewApiKey(response.data.apiKey);
            setHasRenewedKey(true);
            dispatch((0, settingsSlice_1.fetchSiteDetails)(domain));
        })
            .catch(function (error) {
            if (error.response && error.response.status === 429) {
                notifier_1.default.error(t('settings:API_INTEGRATION.MODAL.ERROR_RENEWING_KEY_LIMIT'));
            }
            else {
                notifier_1.default.error(t('settings:API_INTEGRATION.MODAL.ERROR_RENEWING_KEY'));
            }
        })
            .finally(function () {
            setFetchingNewKey(false);
        });
    };
    var copyApiKey = function () {
        if (apiInputElement.current && hasClipboardSupport) {
            apiInputElement.current.select();
            navigator.clipboard.writeText(newApiKey);
        }
    };
    return (react_1.default.createElement(Modal_1.default, { isOpen: isOpen, setIsOpen: setIsOpen, modalContentClassName: "api-modal" },
        react_1.default.createElement("h3", null, t('settings:API_INTEGRATION.MODAL.RENEW_TITLE')),
        !hasRenewedKey ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null, t('settings:API_INTEGRATION.MODAL.RENEW_CONFIRM_TITLE')),
            react_1.default.createElement("p", null,
                t('settings:API_INTEGRATION.MODAL.RENEW_CONFIRM_TEXT1'),
                react_1.default.createElement("br", null),
                react_1.default.createElement("b", null, t('settings:API_INTEGRATION.MODAL.RENEW_CONFIRM_TEXT2'))),
            react_1.default.createElement("h4", null, t('settings:API_INTEGRATION.MODAL.RENEW_CONFIRM_TEXT3')),
            react_1.default.createElement(Checklist_1.default, { conditions: conditions, setConditions: setConditions }),
            react_1.default.createElement("div", { className: "api-modal-buttons" },
                react_1.default.createElement(Button_1.SecondaryButton, { text: t('settings:API_INTEGRATION.CANCEL_RENEW_BUTTON'), onClick: function () { return setIsOpen(false); } }),
                react_1.default.createElement(Button_1.default, { text: "Confirm", onClick: renewApiKey, disabled: !isAllConditionsConfirmed })))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null, t('settings:API_INTEGRATION.MODAL.RENEW_SUCCESS')),
            react_1.default.createElement("b", null, t('settings:API_INTEGRATION.MODAL.RENEW_SUCCESS_TEXT')),
            fetchingNewKey ? (react_1.default.createElement(Loading_1.default, null)) : (react_1.default.createElement("div", { className: "api-integration-settings__item__container" },
                react_1.default.createElement("input", { className: "api-integration-settings__item__input", readOnly: true, ref: apiInputElement, value: newApiKey }),
                hasClipboardSupport && (react_1.default.createElement(Button_1.default, { text: t('settings:API_INTEGRATION.COPY_BUTTON'), onClick: copyApiKey, className: "btn" }))))))));
}
exports.default = RenewApiKeyModal;
